import {MdOutlineDepartureBoard} from "react-icons/md";

/**
 * Ikona tablicy odjazdów
 * @returns {JSX.Element}
 * @constructor
 */
export default function DepartureBoard(){
    return <MdOutlineDepartureBoard />
}
